import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ShoppingBag, ArrowRight } from 'lucide-react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

const EventMerchStrip = ({ eventId }) => {
  const [products, setProducts] = useState([]);

  useEffect(() => {
    if (!eventId) return;
    axios.get(`${API}/api/merch/products?event_id=${eventId}`)
      .then(r => setProducts((r.data.products || []).slice(0, 4)))
      .catch(() => {});
  }, [eventId]);

  if (products.length === 0) return null;

  return (
    <motion.div initial={{ opacity: 0, y: 14 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
      className="mt-8 rounded-2xl border border-[#D4AF37]/25 bg-gradient-to-r from-[#14100a] to-transparent p-5" data-testid="event-merch-strip">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-white font-black uppercase tracking-widest text-sm flex items-center gap-2">
          <ShoppingBag size={15} className="text-[#D4AF37]" /> Merch del evento
        </h3>
        <Link to={`/tienda?evento=${eventId}`} className="text-[#D4AF37] text-xs font-bold flex items-center gap-1 hover:text-[#F2D272]" data-testid="event-merch-see-all">
          Ver tienda <ArrowRight size={12} />
        </Link>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        {products.map(p => (
          <Link key={p.id} to={`/tienda?evento=${eventId}`} className="rounded-xl border border-white/10 overflow-hidden bg-white/[0.03] hover:border-[#D4AF37]/50 transition-colors group" data-testid={`event-merch-item-${p.id}`}>
            <div className="aspect-square bg-[#121212]">
              {(p.images || [])[0] ? (
                <img src={p.images[0]} alt={p.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
              ) : (
                <div className="w-full h-full flex items-center justify-center"><ShoppingBag size={22} className="text-white/15" /></div>
              )}
            </div>
            <div className="p-2.5">
              <p className="text-white text-xs font-bold truncate">{p.name}</p>
              <p className="text-[#D4AF37] text-xs font-black">${Number(p.price).toLocaleString('es-AR')}</p>
            </div>
          </Link>
        ))}
      </div>
    </motion.div>
  );
};

export default EventMerchStrip;
